<script>
export default {
    inserted: function (el) {
        var items = el.getElementsByClassName('item');
        var controls = el.getElementsByClassName('controls');
        var control_items = controls[0].children[0].children;
        var current_page = 0;
        var skip = false;
        
        var setHeights = function() {
            for(var i = 0; i < items.length; i++) {
                items[i].style.height = '';
            }
            var max_height = 0;
            for(var i = 0; i < items.length; i++) {
                if (items[i].offsetHeight > max_height) {
                    max_height = items[i].offsetHeight;
                }
            }
            for(var i = 0; i < items.length; i++) {
                items[i].style.height = max_height + 'px';
            }
            items[0].parentNode.style.height = max_height + 'px';
        }
        
        var setPage = function(new_page) {
            items[current_page].classList.remove('active');
            control_items[current_page].classList.remove('active');

            if (new_page >= items.length) {
                current_page = 0;
            } else {
                current_page = new_page;
            }

            items[current_page].classList.add('active');
            control_items[current_page].classList.add('active');

            el.classList.remove('light');
            el.classList.remove('dark');
            if (items[current_page].dataset.display && items[current_page].dataset.display !== '') {
                el.classList.add(items[current_page].dataset.display);
            }
        };

        var addClickListener = function(num) {
            control_items[num].addEventListener('click', function() {
                skip = true;
                setPage(num);
            });
        }

        window.addEventListener('resize', setHeights);

        for(var i = 0; i < control_items.length; i++) {
            addClickListener(i);
        }

        setHeights();

        setInterval(function() {
            if (!skip) {
                setPage(current_page + 1)
            } else {
                skip = false;
            }
        }, 5000);
    }
}
</script>